export const getErrorMessage = (errorObj: any): string => {
  if (typeof errorObj === "string") return errorObj;
  if (errorObj && typeof errorObj === "object" && "message" in errorObj) {
    return typeof errorObj.message === "string" ? errorObj.message : "";
  }
  return "";
};

export const getStatus = (
  error: any,
  errorMessage: string | undefined,
  success: boolean | undefined
): "default" | "error" | "success" => {
  if (error || errorMessage) return "error";
  if (success) return "success";
  return "default";
};
